/**
 * Central, editable assumptions — CLAUDE.md "Money & assumptions".
 * Every calculator config reads its defaults from here (via AssumptionsContext) instead of
 * hardcoding rates, so one edit updates every calculator.
 */
export const DEFAULT_ASSUMPTIONS = {
  equityReturn: 0.12,
  debtReturn: 0.07,
  inflation: 0.06,
};

export const ASSUMPTIONS_STORAGE_KEY = "srw-assumptions";
